import { useWeb3Provider } from '@trustpad/launchpad';
import { GenericContractSendMethod } from '@trustpad/launchpad/dist/types';
import { useMemo } from 'react';
import { DHControllerABI } from '~features/diamondHands/abi';
import {
  DHDistribution,
  DHUserState,
} from '~features/diamondHands/useDHDistribution';
import { Contract } from '~types';

export const DHControllerAddress = process.env.DH_CONTROLLER_ADDRESS;

export function useDHControllerContract() {
  const { web3 } = useWeb3Provider();

  return useMemo(() => {
    if (!web3) return;
    return new web3.eth.Contract(
      DHControllerABI,
      DHControllerAddress,
    ) as DHControllerContract;
  }, [web3]);
}

export interface DHControllerContract extends Contract {
  methods: {
    curDistrIdx(): GenericContractSendMethod<number>;
    getDistribution(
      distributionIdx: number,
    ): GenericContractSendMethod<DHDistribution>;
    getUserDHState(account: string): GenericContractSendMethod<DHUserState>;
    getRegistrants(
      distributionIdx: number,
    ): GenericContractSendMethod<string[]>;
    register(): GenericContractSendMethod<void>;
  } & {
    // Admin methods
    setCurrentDistributionIndex(
      distrIdx: number,
      start: number,
    ): GenericContractSendMethod;
    setDistributionStart(
      distrIdx: number,
      start: number,
    ): GenericContractSendMethod;
    setPeriods(
      registrationPeriod: number,
      claimPeriod: number,
    ): GenericContractSendMethod;
  };
}
